/*
 * Copyright (c) Kalaora 2022.
 * Author: fharold
 *
 * hilo-oauth-manager
 * ServiceRepositoryHelper.ts
 */

import AuthenticationService from "./AuthenticationService";
import KareviHTTPService from "./KareviHTTPService";
import NavigationService from "./NavigationService";
import TranslationService from "../translation/TranslationService";
import {Service} from "./Service";
import OAuthHTTPService from "./OAuthHTTPService";

export default class ServiceRepository {
    private static _instance?: ServiceRepository;
    private _services: Map<string, Service<any, any>> = new Map();

    /**
     * @return ServiceRepository
     */
    public static get instance(): ServiceRepository {
        if (!this._instance) {
            this._instance = new ServiceRepository();
        }

        return this._instance;
    }

    constructor() {
        let authService = new AuthenticationService();

        this._services.set(TranslationService.id, new TranslationService())
        this._services.set(AuthenticationService.id, authService)
        this._services.set(OAuthHTTPService.id, new OAuthHTTPService(authService))
        this._services.set(KareviHTTPService.id, new KareviHTTPService(authService))
        this._services.set(NavigationService.id, new NavigationService())
    }

    public startServices() {
        this._services.forEach(svc => {
            if (!svc.started) {
                svc.start()
            }
        });
    }

    public resolve(svcName: string): Service<any, any> {
        return this._services.get(svcName)!
    }

    public insert(svcName: string, svc: Service<any, any>) {
        this._services.set(svcName, svc)
    }
}